import React from 'react'
import UnitCountThree from './child/UnitCountThree'
import CoinAnalyticsOne from './child/CoinAnalyticsOne'
import CoinAnalyticsTwo from './child/CoinAnalyticsTwo'
import MyOrdersOne from './child/MyOrdersOne'
import RecentTransactionOne from './child/RecentTransactionOne'
import MyCardsOne from './child/MyCardsOne'
import TotalBalanceOne from './child/TotalBalanceOne'
import UserActivatesOne from './child/UserActivatesOne'
import UnitCountFour from './child/UnitCountFour'
import PackegeTable from './PackegeTable'

const DashBoardLayerFour = () => {
  return (
    <>
      <UnitCountFour />
      <PackegeTable />

    </>
  )
}

export default DashBoardLayerFour